import { createContext, useContext } from 'react'

import type { BCStepName } from '../constants/bc-config'

export interface BusinessCreateFooterConfig {
  buttonText?: string
  buttonVariant?: 'default' | 'ghost'
  primaryAction?: () => void
  secondaryButton?: {
    text: string
    onClick: () => void
  }
}

interface BusinessCreateContextType {
  /** @param skip - The number of steps to skip. Default is 0. */
  handleNext: (skip?: number) => void
  handleGoToStep: (step: BCStepName) => void
  handleBack: () => void
  setFooterConfig: (config: BusinessCreateFooterConfig | null) => void
}

export const BusinessCreateContext = createContext<BusinessCreateContextType>({
  handleNext: () => {},
  handleGoToStep: () => {},
  handleBack: () => {},
  setFooterConfig: () => {},
})

export const useBusinessCreateContext = () => {
  const context = useContext(BusinessCreateContext)
  if (!context) {
    throw new Error('useBusinessCreateContext must be used within a BusinessCreateContextProvider')
  }
  return context
}
